/* =========================================================
   AURMANS — theme.js
   Small, dependency-free interactions. No frameworks.
   ========================================================= */
(function () {
  'use strict';

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Translatable UI strings (rendered by layout/theme.liquid from the locale files) ---------- */
  var STRINGS = (function () {
    var el = document.getElementById('aurmans-strings');
    var data = {};
    if (el) { try { data = JSON.parse(el.textContent); } catch (e) { data = {}; } }
    return data;
  })();
  function str(key, fallback) { return STRINGS[key] || fallback; }

  /* ---------- Mobile menu ---------- */
  function initMobileMenu() {
    var openBtns = qsa('[data-menu-open]');
    var closeBtns = qsa('[data-menu-close]');
    var menu = qs('#mobile-menu');
    if (!menu) return;
    openBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        menu.hidden = false;
        document.body.style.overflow = 'hidden';
      });
    });
    closeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        menu.hidden = true;
        document.body.style.overflow = '';
      });
    });
  }

  /* ---------- Categories mega menu (click/touch + keyboard) ---------- */
  function initMegaMenu() {
    qsa('[data-cats-trigger]').forEach(function (wrap) {
      var btn = qs('[data-cats-btn]', wrap);
      if (!btn) return;
      function close() { wrap.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }
      function toggle() {
        var open = wrap.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      btn.addEventListener('click', function (e) { e.stopPropagation(); toggle(); });
      document.addEventListener('click', function (e) {
        if (!wrap.contains(e.target)) close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close();
      });
    });
  }

  /* ---------- Language selector (footer) + one-time country-based language switch ---------- */
  var LANG_COOKIE = 'aur_lang_chosen';
  function hasLangCookie() { return document.cookie.indexOf(LANG_COOKIE + '=1') !== -1; }
  function setLangCookie() { document.cookie = LANG_COOKIE + '=1; path=/; max-age=31536000; SameSite=Lax'; }

  function initLanguageSelector() {
    qsa('[data-lang-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        setLangCookie(); // an explicit choice always wins over the automatic country-based switch
        if (select.form) select.form.submit();
      });
    });

    // Visitors from the configured countries get the matching language once, on their first visit.
    var form = qs('[data-geo-lang]');
    if (!form || hasLangCookie()) return;
    if (/bot|crawl|spider|slurp|lighthouse/i.test(navigator.userAgent)) return;
    var countries = (form.getAttribute('data-geo-countries') || '').split(',');
    var target = form.getAttribute('data-geo-target');
    var select = qs('[data-lang-select]', form);
    if (!select || !target) return;
    if (form.getAttribute('data-current-lang') === target) return;
    if (countries.indexOf(form.getAttribute('data-country')) === -1) return;
    if (!qs('option[value="' + target + '"]', select)) return;
    // Same rule as the early switch in layout/theme.liquid: countries outside every active market are served
    // as Spain, so also require a Spanish-speaking browser (main language es, or Spain's ca / eu / gl).
    var lang = ((navigator.languages && navigator.languages[0]) || navigator.language || '').toLowerCase();
    if (!/^(es|ca|eu|gl)(-|$)/.test(lang)) return;
    setLangCookie();
    select.value = target;
    form.submit();
  }

  /* ---------- Quantity steppers ---------- */
  function initQtySteppers() {
    qsa('[data-qty-stepper]').forEach(function (stepper) {
      var input = qs('input', stepper);
      var min = parseInt(input.min || '1', 10);
      stepper.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-qty-dec],[data-qty-inc]');
        if (!btn) return;
        var val = parseInt(input.value || '1', 10) || min;
        if (btn.hasAttribute('data-qty-dec')) val = Math.max(min, val - 1);
        else val = val + 1;
        input.value = val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ---------- Cart count / drawer-less AJAX add ---------- */
  var cartState = { count: null };

  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0 && el.hasAttribute('data-hide-when-zero');
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function initCartCountSync() {
    fetchCart().then(function (cart) { updateCartCount(cart.item_count); }).catch(function () {});
  }

  function initAjaxAddToCart() {
    qsa('form[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        // Let Shopify's accelerated checkout ("Buy it now") buttons submit natively; only the add button is AJAX.
        if (e.submitter && !e.submitter.hasAttribute('data-add-btn')) return;
        e.preventDefault();
        var btn = qs('[data-add-btn]', form);
        if (btn && btn.getAttribute('aria-busy') === 'true') return; // one request at a time
        var label = btn ? (qs('[data-add-label]', btn) || btn) : null;
        var status = qs('[data-form-status]', form);
        var panel = qs('[data-added-panel]', form); // the product page shows its own confirmation
        function restore() {
          if (!btn) return;
          btn.removeAttribute('aria-busy');
          var soldOut = btn.getAttribute('data-available') === 'false';
          btn.disabled = soldOut;
          label.textContent = soldOut
            ? (btn.getAttribute('data-label-sold-out') || label.dataset.originalText)
            : (btn.getAttribute('data-label-add') || label.dataset.originalText);
        }
        if (btn) {
          btn.disabled = true;
          btn.setAttribute('aria-busy', 'true');
          label.dataset.originalText = label.dataset.originalText || label.textContent;
          label.textContent = str('adding', 'Adding…');
        }
        if (status) status.hidden = true;
        form.dispatchEvent(new CustomEvent('aur:cart-adding', { bubbles: true }));
        // A pack builder (product.js) can answer with several lines to add at once; otherwise the form is sent as is.
        var itemsEvent = new CustomEvent('aur:cart-items', { detail: { items: null } });
        form.dispatchEvent(itemsEvent);
        var request = { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) };
        if (itemsEvent.detail.items) {
          request.headers['Content-Type'] = 'application/json';
          request.body = JSON.stringify({ items: itemsEvent.detail.items });
        }
        fetch('/cart/add.js', request)
          .then(function (r) {
            if (!r.ok) return r.json().then(function (err) { throw err; });
            return r.json();
          })
          .then(function (item) {
            if (status && !panel) { status.textContent = str('added_to_cart', 'Added to cart.'); status.hidden = false; }
            if (label) { label.textContent = str('added', 'Added'); }
            initCartCountSync();
            form.dispatchEvent(new CustomEvent('aur:cart-added', { bubbles: true, detail: { item: item } }));
            setTimeout(function () {
              restore();
              if (status && !panel) status.hidden = true;
            }, 1800);
          })
          .catch(function (err) {
            var msg = (err && err.description) || str('add_error', 'Could not add this item to your cart.');
            if (status) { status.textContent = msg; status.hidden = false; }
            restore();
            form.dispatchEvent(new CustomEvent('aur:cart-error', { bubbles: true, detail: { message: msg } }));
          });
      });
    });
  }

  /* ---------- Cart page line updates ---------- */
  function initCartLineUpdates() {
    qsa('[data-cart-line]').forEach(function (line) {
      var key = line.getAttribute('data-cart-line');
      var input = qs('input[name="updates[]"]', line) || qs('input[data-qty-input]', line);
      var removeBtn = qs('[data-remove-line]', line);

      function change(qty) {
        line.classList.add('is-updating');
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        })
          .then(function (r) { return r.json(); })
          .then(function () { window.location.reload(); })
          .catch(function () { line.classList.remove('is-updating'); });
      }

      if (input) {
        input.addEventListener('change', function () {
          var v = Math.max(0, parseInt(input.value, 10) || 0);
          change(v);
        });
      }
      if (removeBtn) {
        removeBtn.addEventListener('click', function () { change(0); });
      }
    });
  }

  /* ---------- Product gallery ---------- */
  function initGallery() {
    qsa('[data-gallery]').forEach(function (gallery) {
      var main = qs('[data-gallery-main]', gallery);
      qsa('[data-gallery-thumb]', gallery).forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          qsa('[data-gallery-thumb]', gallery).forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
          if (main) {
            var full = thumb.getAttribute('data-full');
            var alt = thumb.getAttribute('data-alt') || '';
            if (full) {
              main.src = full;
              main.alt = alt;
            }
          }
        });
      });
    });
  }

  /* ---------- Variant / option selection ---------- */
  function initVariantPicker() {
    qsa('[data-variant-picker]').forEach(function (root) {
      var variantsJson = root.getAttribute('data-variants');
      if (!variantsJson) return;
      var variants;
      try { variants = JSON.parse(variantsJson); } catch (e) { return; }
      if (!variants || !variants.length) return;

      var idInput = qs('[data-variant-id]', root);
      var priceEl = qs('[data-variant-price]', root);
      var saveEl = qs('[data-variant-save]', root);
      var addBtn = qs('[data-add-btn]', root);
      var addLabel = addBtn ? (qs('[data-add-label]', addBtn) || addBtn) : null;
      var stockNote = qs('[data-stock-note]', root);
      var groups = qsa('[data-option-index]', root);

      function idxOf(group) { return parseInt(group.getAttribute('data-option-index'), 10); }

      function selectedOptions() {
        var opts = [];
        groups.forEach(function (group) {
          var active = qs('.is-active[data-option-value]', group);
          var select = qs('select[data-option-value]', group);
          opts[idxOf(group)] = active ? active.getAttribute('data-option-value') : (select ? select.value : undefined);
        });
        return opts;
      }

      function matchesUpTo(v, opts, upto) {
        for (var i = 0; i <= upto; i++) {
          if (opts[i] !== undefined && v.options[i] !== opts[i]) return false;
        }
        return true;
      }

      // The exact combination when it exists. Otherwise keep the options up to the one just changed and
      // take the first available variant, so the page never shows one combination and sells another.
      function resolve(opts, changed) {
        var exact = variants.filter(function (v) { return matchesUpTo(v, opts, opts.length - 1); })[0];
        if (exact) return exact;
        var pool = variants.filter(function (v) { return matchesUpTo(v, opts, changed); });
        return pool.filter(function (v) { return v.available; })[0] || pool[0] || variants[0];
      }

      function formatMoney(cents) {
        return (cents / 100).toLocaleString(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: root.getAttribute('data-currency') || 'EUR'
        });
      }

      // Reflect the variant on every option: the selected value, values that don't exist together with
      // the options chosen before them (disabled) and values that exist but are sold out (marked).
      function syncOptions(variant) {
        groups.forEach(function (group) {
          var idx = idxOf(group);
          var current = variant.options[idx];
          qsa('[data-option-value]', group).forEach(function (el) {
            if (el.tagName === 'SELECT') { el.value = current; return; }
            var val = el.getAttribute('data-option-value');
            var active = val === current;
            el.classList.toggle('is-active', active);
            el.setAttribute('aria-pressed', active ? 'true' : 'false');
            var candidates = variants.filter(function (v) {
              if (v.options[idx] !== val) return false;
              for (var i = 0; i < idx; i++) { if (v.options[i] !== variant.options[i]) return false; }
              return true;
            });
            el.disabled = candidates.length === 0;
            el.classList.toggle('is-unavailable', candidates.length > 0 && !candidates.some(function (v) { return v.available; }));
          });
          var selectedLabel = qs('[data-option-selected]', group);
          if (selectedLabel) selectedLabel.textContent = current;
        });
      }

      function render(variant, updateUrl) {
        if (idInput) idInput.value = variant.id;
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (priceEl) {
          if (onSale) {
            priceEl.innerHTML = '<s>' + formatMoney(variant.compare_at_price) + '</s>' + formatMoney(variant.price);
          } else {
            priceEl.textContent = formatMoney(variant.price);
          }
          priceEl.classList.toggle('product-price--sale', !!onSale);
        }
        if (saveEl) {
          var pct = onSale ? Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) : 0;
          saveEl.hidden = !(pct > 0);
          if (pct > 0) saveEl.textContent = (saveEl.getAttribute('data-label') || '-__PERCENT__%').replace('__PERCENT__', pct);
        }
        if (addBtn) {
          addBtn.setAttribute('data-available', variant.available ? 'true' : 'false');
          if (addBtn.getAttribute('aria-busy') !== 'true') {
            addBtn.disabled = !variant.available;
            addLabel.textContent = variant.available ? addBtn.getAttribute('data-label-add') : addBtn.getAttribute('data-label-sold-out');
          }
        }
        if (stockNote) {
          if (!variant.available) {
            stockNote.textContent = str('sold_out', 'Sold out');
            stockNote.classList.add('is-out');
          } else if (variant.inventory_management && variant.inventory_quantity <= 5 && variant.inventory_quantity > 0) {
            stockNote.textContent = str('only_left', 'Only __COUNT__ left').replace('__COUNT__', variant.inventory_quantity);
            stockNote.classList.remove('is-out');
          } else {
            stockNote.textContent = str('in_stock', 'In stock');
            stockNote.classList.remove('is-out');
          }
        }
        syncOptions(variant);

        if (updateUrl) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
        root.dispatchEvent(new CustomEvent('aur:variant-change', { bubbles: true, detail: { variant: variant, userAction: !!updateUrl } }));
      }

      root.addEventListener('click', function (e) {
        var pill = e.target.closest('[data-option-value]');
        if (!pill || pill.tagName === 'OPTION' || pill.tagName === 'SELECT' || pill.disabled) return;
        var group = pill.closest('[data-option-index]');
        if (!group) return;
        qsa('[data-option-value]', group).forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        render(resolve(selectedOptions(), idxOf(group)), true);
      });
      root.addEventListener('change', function (e) {
        if (!e.target.matches('select[data-option-value]')) return;
        var group = e.target.closest('[data-option-index]');
        render(resolve(selectedOptions(), group ? idxOf(group) : 0), true);
      });

      var initialId = idInput ? parseInt(idInput.value, 10) : NaN;
      var initial = variants.filter(function (v) { return v.id === initialId; })[0] || resolve(selectedOptions(), 0);
      render(initial, false);
    });
  }

  /* ---------- Featured product filter chips (client-side) ---------- */
  function initFilterChips() {
    qsa('[data-filter-group]').forEach(function (group) {
      var grid = document.getElementById(group.getAttribute('data-filter-group'));
      if (!grid) return;
      group.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-filter-value]');
        if (!chip) return;
        qsa('[data-filter-value]', group).forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        var value = chip.getAttribute('data-filter-value');
        qsa('[data-filter-item]', grid).forEach(function (item) {
          var tags = (item.getAttribute('data-filter-item') || '').split('|');
          item.hidden = value !== 'all' && tags.indexOf(value) === -1;
        });
      });
    });
  }

  /* ---------- Product cards: quick add sheet (variant choice + add button) ----------
     Delegated, so cards injected later (product recommendations) open too. The add itself is the usual
     [data-product-form] AJAX submit (initAjaxAddToCart); the variant select is required, so nothing is sent
     until a variant is chosen. */
  function initQuickAdd() {
    function triggerOf(sheet) {
      var card = sheet && sheet.closest('.product-card');
      return card ? qs('[data-quick-open]', card) : null;
    }
    function close(sheet, refocus) {
      if (!sheet || sheet.hidden) return;
      sheet.hidden = true;
      var t = triggerOf(sheet);
      if (t) { t.setAttribute('aria-expanded', 'false'); if (refocus) t.focus(); }
    }
    function open(trigger) {
      var sheet = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!sheet) return;
      qsa('[data-quick-sheet]').forEach(function (s) { if (s !== sheet) close(s); });
      sheet.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      var first = qs('select, [data-add-btn]', sheet);
      if (first) first.focus({ preventScroll: true });
    }
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var t = e.target.closest('[data-quick-open]');
      if (t) {
        e.preventDefault();
        var s = document.getElementById(t.getAttribute('aria-controls'));
        if (s && !s.hidden) close(s); else open(t);
        return;
      }
      var c = e.target.closest('[data-quick-close]');
      if (c) { close(c.closest('[data-quick-sheet]'), true); return; }
      if (!e.target.closest('[data-quick-sheet]')) qsa('[data-quick-sheet]').forEach(function (s) { close(s); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      qsa('[data-quick-sheet]').forEach(function (s) { if (!s.hidden) close(s, true); });
    });
    // Say what is missing instead of the browser's generic bubble.
    document.addEventListener('invalid', function (e) {
      var sel = e.target;
      if (!sel.matches || !sel.matches('[data-quick-select]')) return;
      e.preventDefault();
      var status = qs('[data-form-status]', sel.form);
      if (status) { status.textContent = sel.getAttribute('data-error') || ''; status.hidden = false; }
      sel.focus();
    }, true);
    document.addEventListener('change', function (e) {
      if (!e.target.matches || !e.target.matches('[data-quick-select]')) return;
      var status = qs('[data-form-status]', e.target.form);
      if (status) status.hidden = true;
    });
    // After a real add, leave "Added" visible for a moment, then fold the sheet away.
    document.addEventListener('aur:cart-added', function (e) {
      var sheet = e.target.closest && e.target.closest('[data-quick-sheet]');
      if (sheet) setTimeout(function () { close(sheet); }, 1600);
    });
  }

  /* ---------- Forms that apply on change (collection sorting); the button stays for no-JS ---------- */
  function initAutoSubmit() {
    qsa('form[data-auto-submit]').forEach(function (form) {
      var btn = qs('[data-auto-submit-btn]', form);
      if (btn) btn.style.display = 'none';
      form.addEventListener('change', function () { form.submit(); });
    });
  }

  /* ---------- Cart discount code (applies via Shopify's /discount/:code route) ---------- */
  function initDiscountForm() {
    qsa('[data-discount-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = qs('input[name="code"]', form);
        var code = input && input.value.trim();
        if (!code) return;
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart');
      });
    });
  }

  /* ---------- Native product recommendations (Section Rendering API) ---------- */
  function initProductRecommendations() {
    qsa('[data-recommendations-url]').forEach(function (el) {
      var url = el.getAttribute('data-recommendations-url');
      if (!url) return;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var content = doc.querySelector('[data-recommendations-content]');
          if (content && content.innerHTML.trim() !== '') {
            el.innerHTML = content.innerHTML;
          } else {
            el.remove();
          }
        })
        .catch(function () {});
    });
  }

  /* ---------- Newsletter (native customer form enhancement) ---------- */
  function initNewsletterFeedback() {
    qsa('[data-newsletter-form]').forEach(function (form) {
      form.addEventListener('submit', function () {
        var note = qs('[data-newsletter-note]', form.parentNode);
        if (note) note.hidden = false;
      });
    });
  }

  /* ---------- "Cookie settings" link: reopens Shopify's cookie banner; without it, the link just opens the cookie policy ---------- */
  function initCookieSettings() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-cookie-settings]');
      if (!link || !window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') return;
      e.preventDefault();
      window.privacyBanner.showPreferences();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileMenu();
    initMegaMenu();
    initLanguageSelector();
    initQtySteppers();
    initAjaxAddToCart();
    initCartLineUpdates();
    initGallery();
    initVariantPicker();
    initFilterChips();
    initQuickAdd();
    initAutoSubmit();
    initNewsletterFeedback();
    initDiscountForm();
    initCartCountSync();
    initProductRecommendations();
    initCookieSettings();
  });
})();
